import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IconMessage, IconMail, IconWebhook, IconArrowRight, IconArrowLeft } from "@tabler/icons-react";
import "./TemplateTypeSelector.css";

const TemplateTypeSelector = () => {
  const navigate = useNavigate();
  const { agentId } = useParams();
  
  // Detecta se está no contexto do AgentHub
  const isInsideAgentHub = Boolean(agentId) || window.location.pathname.includes('/agent-hub/');

  const getTemplateTypes = () => [
    {
      id: "whatsapp",
      title: "WhatsApp",
      description: "Crie templates para mensagens do WhatsApp",
      icon: IconMessage,
      gradient: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
      route: isInsideAgentHub ? `/agent-hub/${agentId}/templates/whatsapp/create` : "/templates/whatsapp/create"
    },
    {
      id: "email",
      title: "E-mail",
      description: "Crie templates para envio de e-mails",
      icon: IconMail,
      gradient: "linear-gradient(135deg, #4285F4 0%, #1A73E8 100%)",
      route: isInsideAgentHub ? `/agent-hub/${agentId}/templates/email/create` : "/templates/email/create"
    },
    {
      id: "webhook",
      title: "Webhook",
      description: "Configure integrações com sistemas externos via webhook",
      icon: IconWebhook,
      gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
      route: isInsideAgentHub ? `/agent-hub/${agentId}/templates/webhook/create` : "/templates/webhook/create"
    }
  ];

  const handleTypeSelect = (type) => {
    navigate(type.route);
  };

  return (
    <div className="template-type-selector-page">
      <div className="template-type-selector-container">
        <div className="template-type-selector-header">
          <div className="template-type-selector-header-left">
            <button className="template-type-selector-back-button" onClick={() => {
              if (isInsideAgentHub) {
                navigate(`/agents/${agentId}/hub`);
              } else {
                navigate('/templates');
              }
            }}>
              <IconArrowLeft size={20} />
            </button>
            <div>
              <h1 className="template-type-selector-title">Escolha o Tipo de Template</h1>
              <p className="template-type-selector-subtitle">Selecione como você deseja se comunicar com seus clientes</p>
            </div>
          </div>
        </div>

        <div className="template-type-selector-cards">
          {getTemplateTypes().map((type) => {
            const IconComponent = type.icon;
            return (
              <div
                key={type.id}
                className={`template-type-selector-card template-type-selector-card--${type.id}`}
                onClick={() => handleTypeSelect(type)}
              >
                <div className="template-type-selector-card-content">
                  <div className={`template-type-selector-icon-container template-type-selector-icon-container--${type.id}`}>
                    <IconComponent size={32} color="white" />
                  </div>
                  
                  <div className="template-type-selector-text-content">
                    <h3 className="template-type-selector-card-title">{type.title}</h3>
                    <p className="template-type-selector-card-description">{type.description}</p>
                  </div>
                  
                  <div className="template-type-selector-arrow-container">
                    <IconArrowRight size={20} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};


export default TemplateTypeSelector;